<template>
  <div class="chart" ref="donutChart"></div>
</template>

<script>
import { SIDEBAR_CALLAPSED } from '@/common/events.types'

export default {
  name: 'DonutChart',
  props: [
    'chartData',
    'metric',
    'graphOptions',
    'currentMetric'
  ],
  mounted () {
    this.initChart()

    window.addEventListener('resize', this.initChart)

    this.$eventHub.$on(SIDEBAR_CALLAPSED, () => {
      this.initChart()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.initChart);
    this.$eventHub.$off();
  },
  methods: {
    initChart () {
      const context = this;
      google.charts.load("current", {packages:["corechart"]});
      google.charts.setOnLoadCallback(() => {
        const chartElement = this.$refs.donutChart
        const chart = new google.visualization.PieChart(chartElement)

        chart.draw(google.visualization.arrayToDataTable(context.chartData), context.graphOptions)
      });
    }
  },
  watch: {
    currentMetric () {
      if(window.innerWidth < 768) {
        this.$nextTick(() => { 
          this.initChart()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .chart {
    min-height: 320px;
  }
</style>
